import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Response } from "@angular/http";
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { UserCreation } from './user-creation.model';

@Injectable()
export class UserCreationService {

  // readonly rootUrl = 'http://localhost:14121';
   readonly rootUrl = 'http://unicorewebapi.esdinfra.com';

  httpOptions: any;

  constructor(private http: HttpClient) {
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
        // 'Authorization': 'Bearer ' + accesstoken
        // 'No-Auth': 'True'
      })
    };



    // let accesstoken = localStorage.getItem('accessToken');
    // if (accesstoken != null && accesstoken != '' && typeof (accesstoken) != undefined) {
    //   this.httpOptions = {
    //     headers: new HttpHeaders({
    //       'Content-Type': 'application/json'
    //       // 'Authorization': 'Bearer ' + accesstoken
    //       // 'No-Auth': 'True'
    //     })
    //   }; 
    // }
  }

  createArea(areaDetails: any) {
    debugger;
    console.log(areaDetails);
    return this.http.post(this.rootUrl + '/api/Areas/CreateArea', areaDetails, this.httpOptions);
  }


  GetAllTaluks() {
    return this.http.get(this.rootUrl + '/api/Areas/GetAllTaluks/', this.httpOptions);
  }

  GetMaxAreaCode() {
    debugger;
    return this.http.get(this.rootUrl + '/api/Areas/GetMaxAreaCode/', this.httpOptions);
  }
  
  Getalldistrictdetails(talukid:any) {

    return this.http.get(this.rootUrl + '/api/Areas/Getalldistrictdetails/'+talukid, this.httpOptions);
  }

  GetAllArea(itemsPerPage:number,pageNo:number){
    debugger;
    return this.http.get(this.rootUrl + '/api/Areas/GetallAreaDetails/'+itemsPerPage+"/"+pageNo, this.httpOptions);
  }

  SearchAreas(searchCriteria:any,searchText:any, itemsPerPage:number, pageNo: number) {
    debugger;
    return this.http.get(this.rootUrl + '/api/Areas/Search/'+searchCriteria+"/"+searchText+ "/"+itemsPerPage+"/"+pageNo, this.httpOptions);
  } 

  GetAreaForTheId(ACODE: any) {
    return this.http.get(this.rootUrl + '/api/Areas/' + ACODE, this.httpOptions);
}

updateArea(Area:any,ACODE:string) {
debugger;
  return this.http.put(this.rootUrl + '/api/Areas/Update/'+ACODE, Area, this.httpOptions);
}


}


// WEBPACK FOOTER //
// ./src/app/shared/user-creation.service.ts